'use client';

const defaultProps = {
  iconStyle: "default",
  iconPosition: "lead",
  inputSize: "md"
};
export {
  defaultProps
};
